import axios from 'axios';
import { baseURL } from '../data/config';
axios.defaults.timeout = 60000;

export type StandardError = {
  status: string;
  message: string; // eslint-disable-next-line @typescript-eslint/no-explicit-any
  code: number; // eslint-disable-next-line @typescript-eslint/no-explicit-any
};

/* eslint-disable no-unused-vars */
type requestParams = {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  url: string | undefined;
  baseUrl?: string;
  formData?: { [key: string]: any };
  params?: Record<string, string>;
  headers?: Record<string, string>;
  callback?: (arg: Record<string, string>) => void;
  onError?: (arg: StandardError) => void;
  signal?: AbortSignal;
};

//axios instance
export const axios_api_instance = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
  },
});

export const request = async ({
  method,
  url = undefined,
  baseUrl = undefined,
  params,
  formData,
  headers,
  callback,
  onError,
  signal,
}: requestParams) => {
  // Make HTTP request
  try {
    const response = await axios_api_instance({
      method: method,
      url: url,
      baseURL: baseUrl,
      ...(typeof formData === 'undefined' || !formData
        ? {}
        : { data: formData }),
      headers: headers,
      params: params && params,
      signal,
    });
    const responseData = response.data;
    if (typeof callback === 'function') callback(responseData);
    return responseData;
  } catch (err: any) {
    // Narrow the type of `err` and handle it properly
    // const stdErr: StandardError = {
    //   status: 'error',
    //   message:
    //     (axios.isAxiosError(err) && err.response?.data?.message) ||
    //     (err instanceof Error && err.message) ||
    //     err?.toString() ||
    //     'Unknown error',
    //   code:
    //     (axios.isAxiosError(err) &&
    //       (err.response?.data?.code || err.response?.status)) ||
    //     -1,
    // };

    if (typeof onError === 'function') onError(err);
    else {
      throw err;
    }
  }
};
